import React from 'react';

import Layout from '@src/layouts';
import SEO from '@commons/SEO';
import { DesktopHeaderLayoutA, MobileHeaderLayoutA, ContactForm } from '@src/components/commons';

import { TechnologyBlogSection, CaseStudiesSection } from '@pages-impl/case-studies';

import featuredImage from '@images/case-studies/featured-image_case-min.jpg';
import { caseStudiesHeaderProps } from '@pages-impl/case-studies/payload';

export default function Index(props) {
  return (
    <Layout {...props} isShorter={true}>
      <SEO
        title="Case studies | CodiLime"
        description="We have expertise in automation, CI/CD, cloud, low-level programming, monitoring and alerting, network infrastructure planning and many more."
        featuredImage={featuredImage}
      />
      <div className="case-study-library">
        <MobileHeaderLayoutA {...caseStudiesHeaderProps} />
        <DesktopHeaderLayoutA {...caseStudiesHeaderProps} />
        <CaseStudiesSection {...props} />
        <TechnologyBlogSection />
      </div>
      <ContactForm />
    </Layout>
  );
}
